import '../enums/GameSpecificTypes.js';
import '../enums/Chat.js';
import '../enums/GameModes.js';
import '../enums/IconTypes.js';
import '../enums/BetStatus.js';
import '../enums/PopupTypes.js';
import '../enums/ApiVersion.js';
import '../enums/RoundStatus.js';
import '../enums/RequestStatus.js';
import '../enums/FreeBetsStatus.js';
import '../enums/SocketEvents.js';
import '../enums/TranslationKeys.js';
import '../enums/ApiServiceTypes.js';
import { EnvironmentTypes } from '../enums/EnvironmentTypes.js';
import '../enums/DefaultQueryParams.js';
import '../enums/BetHistoryFilterTypes.js';
import '../enums/GameThemeTypes.js';
import '../enums/FetchDefaultPaths.js';
import '../enums/ResponseCodes.js';

var baseUrl = 'https://pg-stage.rpd.cloud';
var translationEndPoint = 'translations/api/v1/Translations';
var bannersEndPoint = 'pg-files';
var liveEnvironment = function (gameNameForUrl) { return ({
    chatHttpUrl: "".concat(window.location.origin, "/chat"),
    httpUrl: "".concat(window.location.origin, "/").concat(gameNameForUrl),
    socketUrl: "".concat(window.location.origin, "/").concat(gameNameForUrl, "/api/"),
    chatSocketUrl: "".concat(window.location.origin, "/chat/api/hubs/chat"),
    httpBannersUrl: "".concat(window.location.origin, "/").concat(bannersEndPoint),
    httpTranslationUrl: "".concat(window.location.origin, "/").concat(translationEndPoint),
}); };
var stageEnvironment = function (gameNameForUrl) { return ({
    chatHttpUrl: "".concat(baseUrl, "/chat"),
    httpUrl: "".concat(baseUrl, "/").concat(gameNameForUrl),
    httpBannersUrl: "".concat(baseUrl, "/").concat(bannersEndPoint),
    socketUrl: "".concat(baseUrl, "/").concat(gameNameForUrl, "/api/"),
    chatSocketUrl: "".concat(baseUrl, "/chat/api/hubs/chat"),
    httpTranslationUrl: "".concat(baseUrl, "/").concat(translationEndPoint),
}); };
var environmentBuilder = function (gameNameForUrl) {
    if (process.env.REACT_APP_ENV === EnvironmentTypes.Production) {
        return liveEnvironment(gameNameForUrl);
    }
    return stageEnvironment(gameNameForUrl);
};

export { environmentBuilder };
